module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ../~/aws-sdk/apis/sts-2011-06-15.paginators.json
// module id = 607
// module chunks = 0